// extracted by mini-css-extract-plugin
module.exports = {"price":"index_price_32Tdo","strikethrough":"index_strikethrough_2QQx1","term":"index_term_2csHa"};